import { dossierSubTypeId as dossierSubTypeIdConstants } from '../dossier/common/dossierSubType'

export const otherDataRequiredFields = (dossierSubtype) => {
  const fields = {}
  fields.laterUseId = 'DOSSIER_COMPONENTS.VALIDATIONS.OTHER_DATA_LATER_USE_MANDATORY'
  fields.activityClientId = 'DOSSIER_COMPONENTS.VALIDATIONS.OTHER_DATA_ACTIVITY_CLIENT_MANDATORY'
  fields.activityBuyerId = 'DOSSIER_COMPONENTS.VALIDATIONS.OTHER_DATA_ACTIVITY_BUYER_MANDATORY'
  if (dossierSubtype === dossierSubTypeIdConstants.compra_vo || dossierSubTypeIdConstants.venta_vo) {
    fields.vehicleTypeId = 'DOSSIER_COMPONENTS.VALIDATIONS.OTHER_DATA_VEHICLE_TYPE_MANDATORY'
    fields.ivaTypeId = 'DOSSIER_COMPONENTS.VALIDATIONS.OTHER_DATA_IVA_TYPE_MANDATORY'
  }
  return fields
}
